<template src="@/templates/reservations/reservation-list.html"></template>

<script>
import userApi from '@/api/userApi';

export default {
  data() {
    return {
      reservations: [],
      isLoading: true,
      prefix: 'vorige',
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      userApi.getPastReservations((data) => {
        this.reservations = data.past_reservations;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// archive.vue?3ac9a2fa